import React, {use, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';

const Structure = () => {

    const slides = [
	{ title: 'Everything is stored locally on your devices. ', text: 'Available on the plane, on the train, even if anytype is not there anymore.' },
	{ title: 'Encrypted with keys you control. ', text: 'No one reads your data — not us, not them, only you.' },
	{ title: 'Open code and open data standard. ', text: 'You\'re never locked in. You own your data forever.', imgWrapperClassName: 'left' },
    ];

    const mapper = (item: any, idx: number) => (
	<SwiperSlide key={idx}>
	    <div className="item">
		<div className={[ 'imgWrapper', item.imgWrapperClassName ? item.imgWrapperClassName : '' ].join(' ')}>
		    <div className={[ 'img', `img${idx + 1}` ].join(' ')} />
		</div>
		<p>
		    <span>{item.title}</span>
		    {item.text}
		</p>
	    </div>
	</SwiperSlide>
    );

    return (
	<div id="Mark1" className="section structure">
	    <h3>yours forever</h3>

	    <div className="swiperWrapper">
		<Swiper
		    slidesPerView={3}
		    spaceBetween={16}
		    slidesOffsetAfter={16}
		    slidesOffsetBefore={16}
		    breakpoints={{
			375: { slidesPerView: 1 },
			400: { slidesPerView: 1.4 },
			500: { slidesPerView: 1.8 },
			600: { slidesPerView: 2 },
			642: { slidesPerView: 2.4 },
			768: { slidesPerView: 2.8, spaceBetween: 16, slidesOffsetAfter: 16, slidesOffsetBefore: 16 },
			800: { slidesPerView: 3, spaceBetween: 32, slidesOffsetAfter: 32, slidesOffsetBefore: 32 },
			1072: { slidesPerView: 3, spaceBetween: 32, slidesOffsetAfter: 0, slidesOffsetBefore: 0 },
		    }}
		>
		    {slides.map(mapper)}
		</Swiper>
	    </div>
	</div>
    );
};

export default Structure;